import { useCallback } from "react";

import type { RoomStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { useCreateRoomStockFormModel } from "./usecase/use-create-form-model";

// eslint-disable-next-line import/no-restricted-paths
import type { ApolloQueryResult } from "@apollo/client";

type Props = {
	serverModel: RoomStock_StockManagementQuery;
	onFetchRoomStock: ({
		input: { startDt, endDt },
	}: {
		input: {
			startDt: string;
			endDt: string;
		};
	}) => Promise<ApolloQueryResult<RoomStock_StockManagementQuery | undefined>>;
};

export const useInitialized = ({ serverModel, onFetchRoomStock }: Props) => {
	const { isDirty, isValid, onUpdateRoomStock, onReInitialize, roomStockDiffStore } = useCreateRoomStockFormModel({
		serverModel,
	});

	const onRefetch = useCallback(
		async (input: { startDt: string; endDt: string }) => {
			const { data: serverModel, error, errors } = await onFetchRoomStock({ input });

			if (error || errors) {
				notifyUserEventInfo({
					variant: "error",
					title: "部屋在庫の取得に失敗しました",
					description: "時間を置いて再度お試しください",
				});
			} else if (serverModel) {
				onReInitialize();
			}
		},
		[onFetchRoomStock, onReInitialize],
	);

	return {
		isDirty,
		isValid,
		onUpdateRoomStock,
		roomStockDiffStore,
		onRefetch,
		serverModel,
	};
};
